function Norway({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1835)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M0.551147 20.1738C1.4769 23.6088 3.51721 26.5859 6.26084 28.694V20.1738H0.551147Z" fill="#D80027"/>
  <path d="M14.6086 31.939C15.0673 31.9785 15.5311 31.9999 16 31.9999C23.3924 31.9999 29.6128 26.9861 31.4488 20.1738H14.6086V31.939Z" fill="#D80027"/>
  <path d="M31.4488 11.8261C29.6128 5.01381 23.3924 0 16 0C15.5311 0 15.0673 0.021375 14.6086 0.060875V11.8261H31.4488Z" fill="#D80027"/>
  <path d="M6.26084 3.30566C3.51721 5.41379 1.4769 8.39085 0.551147 11.8258H6.26084V3.30566Z" fill="#D80027"/>
  <path d="M31.8646 13.9126H12.5218H12.5218V0.379883C11.0431 0.707758 9.64131 1.2392 8.34781 1.94501V13.9125V13.9126H0.135438C0.046375 14.5958 0 15.2923 0 15.9996C0 16.7069 0.046375 17.4034 0.135438 18.0865H8.34775H8.34781V30.0541C9.64131 30.7598 11.0431 31.2914 12.5218 31.6192V18.0867V18.0866H31.8646C31.9535 17.4034 32 16.7069 32 15.9996C32 15.2923 31.9535 14.5958 31.8646 13.9126Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Norway;
